import React, { useState, forwardRef, useImperativeHandle } from "react";
import { Form, Button, Row, Col, Card } from "react-bootstrap";

const FormatIIIForm = forwardRef(({ formData, setFormData, vfcs }, ref) => {
  const [entries, setEntries] = useState(
    Array.isArray(formData.formatIII) ? formData.formatIII : []
  );

  useImperativeHandle(ref, () => ({
    validate: () => {
      return entries.every(
        (entry) =>
          entry.year &&
          entry.workDone &&
          entry.departmentInvolved &&
          entry.amountSpent &&
          entry.nametapVillage
      );
    },
  }));
  const [errors, setErrors] = useState([]);

  const addEntry = () => {
    const updated = [
      ...entries,
      {
        year: "",
        workDone: "",
        departmentInvolved: "",
        amountSpent: "",
        nametapVillage: "",
      },
    ];
    setEntries(updated);
    setFormData({ ...formData, formatIII: updated });
    setErrors([...errors, {}]);
  };

  const handleEntryChange = (index, field, value) => {
    const updatedEntries = entries.map((entry, i) =>
      i === index ? { ...entry, [field]: value } : entry
    );
    setEntries(updatedEntries);
    setFormData({ ...formData, formatIII: updatedEntries });

    const updatedErrors = [...errors];
    if (!value) {
      updatedErrors[index] = { ...updatedErrors[index], [field]: "Required" };
    } else {
      if (updatedErrors[index]) delete updatedErrors[index][field];
    }
    setErrors(updatedErrors);
  };

  const generateYearRanges = (startYear, endYear) => {
    const ranges = [];
    for (let year = startYear; year < endYear; year++) {
      ranges.push(`${year}-${year + 1}`);
    }
    return ranges;
  };

  const yearRanges = generateYearRanges(1999, new Date().getFullYear());

  return (
    <div>
      {entries.map((entry, index) => (
        <Card key={index} className="mb-3">
          <Card.Body>
            <Row className="mb-2">
              <Col md={4}>
                <Form.Group controlId={`year-${index}`}>
                  <Form.Label>Year</Form.Label>
                  <Form.Control
                    as="select"
                    value={entry.year}
                    onChange={(e) =>
                      handleEntryChange(index, "year", e.target.value)
                    }
                    isInvalid={!!errors[index]?.year}
                  >
                    <option value="">Select Year</option>
                    {yearRanges.map((yr) => (
                      <option key={yr} value={yr}>
                        {yr}
                      </option>
                    ))}
                  </Form.Control>
                  <Form.Control.Feedback type="invalid">
                    {errors[index]?.year}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col md={8}>
                <Form.Group controlId={`workDone-${index}`}>
                  <Form.Label>Work Done</Form.Label>
                  <Form.Control
                    type="text"
                    value={entry.workDone}
                    onChange={(e) =>
                      handleEntryChange(index, "workDone", e.target.value)
                    }
                    isInvalid={!!errors[index]?.workDone}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors[index]?.workDone}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>

            <Row className="mb-2">
              <Col md={6}>
                <Form.Group controlId={`department-${index}`}>
                  <Form.Label>Department Involved</Form.Label>
                  <Form.Control
                    type="text"
                    value={entry.departmentInvolved}
                    onChange={(e) =>
                      handleEntryChange(
                        index,
                        "departmentInvolved",
                        e.target.value
                      )
                    }
                    isInvalid={!!errors[index]?.departmentInvolved}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors[index]?.departmentInvolved}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group controlId={`amount-${index}`}>
                  <Form.Label>Amount Spent (Lakhs)</Form.Label>
                  <Form.Control
                    type="number"
                    min={0}
                    value={entry.amountSpent}
                    onChange={(e) =>
                      handleEntryChange(index, "amountSpent", e.target.value)
                    }
                    isInvalid={!!errors[index]?.amountSpent}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors[index]?.amountSpent}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>

            <Form.Group controlId={`vfc-${index}`}>
              <Form.Label>Nametap Village (VFC)</Form.Label>
              <Form.Select
                value={entry.nametapVillage}
                onChange={(e) =>
                  handleEntryChange(index, "nametapVillage", e.target.value)
                }
                isInvalid={!!errors[index]?.nametapVillage}
              >
                <option value="">Select VFC</option>
                {vfcs.map((vfc) => (
                  <option key={vfc._id} value={vfc._id}>
                    {vfc.vfcName}
                  </option>
                ))}
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                {errors[index]?.nametapVillage}
              </Form.Control.Feedback>
            </Form.Group>
          </Card.Body>
        </Card>
      ))}

      <Button variant="primary" onClick={addEntry}>
        Add Entry
      </Button>
    </div>
  );
});

export default FormatIIIForm;
